$(document).ready(function(){
    console.log("ready");
        $(".parlor-nav-item").mouseover(function(){
            console.log("in");
           // $(this).children('.sub-nav').addClass('open');
            $(this).addClass('open');
        });

        $(".parlor-nav-item").mouseout(function(){
            console.log("out");
            //$(this).children('.sub-nav').removeClass('open');
            $(this).removeClass('open');
        });

        $(".parlor-nav-item").click(function(){
            $(".parlor-nav-item").each(function(){
                $(this).removeClass('open');
            });
            $(this).addClass('open');
        });

        $(".menu-toggle").click(function(){
            console.log('toggle');
            $('.parlor-nav-items').toggleClass('show');
            $('body').toggleClass('mobile-nav');
            $(".parlor-nav-item").each(function(){
                $(this).removeClass('open');
            });
            $(".parlor-nav-item:first-of-type").addClass('open');
        });
    
    })